// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2017 TypeFox and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

.theia-marker-container {
  font-size: var(--theia-ui-font-size1);
}

.theia-side-panel .theia-marker-container .noMarkers {
  padding-left: 19px;
}

.theia-marker-container .markerNode,
.theia-marker-container .markerFileNode {
  display: flex;
  align-items: center;
}

.theia-marker-container .markerNode div,
.theia-marker-container .markerFileNode div:not(.file-icon) {
  display: flex;
  margin-right: 5px;
}

.theia-marker-container .markerFileNode .name,
.theia-marker-container .markerFileNode .path {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.theia-marker-container .markerFileNode .path {
  font-size: var(--theia-ui-font-size0);
  align-self: flex-end;
  white-space: nowrap;
}

.theia-marker-container .error {
  color: var(--theia-editorError-foreground);
  opacity: 1;
}

.theia-marker-container .warning {
  color: var(--theia-editorWarning-foreground);
  opacity: 1;
}

.theia-marker-container .information {
  color: var(--theia-editorInfo-foreground);
  opacity: 1;
}

.theia-marker-container .hint {
  color: var(--theia-successBackground);
  opacity: 1;
}

.theia-marker-container .markerNode .position,
.theia-marker-container .markerNode .owner {
  white-space: nowrap;
  margin-left: 5px;
}

.theia-marker-container .markerNode .message {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.theia-marker-container .row-button-container {
  display: none;
}

.theia-marker-container .theia-TreeNodeContent:hover .row-button-container {
  display: flex;
  justify-content: flex-end;
  flex: 1;
  align-items: center;
  align-self: center;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/markers/src/browser/style/index.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,UAAU;AACZ;;AAEA;EACE,4CAA4C;EAC5C,UAAU;AACZ;;AAEA;EACE,yCAAyC;EACzC,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,UAAU;AACZ;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,OAAO;EACP,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":["/********************************************************************************\n * Copyright (C) 2017 TypeFox and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n.theia-marker-container {\n  font-size: var(--theia-ui-font-size1);\n}\n\n.theia-side-panel .theia-marker-container .noMarkers {\n  padding-left: 19px;\n}\n\n.theia-marker-container .markerNode,\n.theia-marker-container .markerFileNode {\n  display: flex;\n  align-items: center;\n}\n\n.theia-marker-container .markerNode div,\n.theia-marker-container .markerFileNode div:not(.file-icon) {\n  display: flex;\n  margin-right: 5px;\n}\n\n.theia-marker-container .markerFileNode .name,\n.theia-marker-container .markerFileNode .path {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.theia-marker-container .markerFileNode .path {\n  font-size: var(--theia-ui-font-size0);\n  align-self: flex-end;\n  white-space: nowrap;\n}\n\n.theia-marker-container .error {\n  color: var(--theia-editorError-foreground);\n  opacity: 1;\n}\n\n.theia-marker-container .warning {\n  color: var(--theia-editorWarning-foreground);\n  opacity: 1;\n}\n\n.theia-marker-container .information {\n  color: var(--theia-editorInfo-foreground);\n  opacity: 1;\n}\n\n.theia-marker-container .hint {\n  color: var(--theia-successBackground);\n  opacity: 1;\n}\n\n.theia-marker-container .markerNode .position,\n.theia-marker-container .markerNode .owner {\n  white-space: nowrap;\n  margin-left: 5px;\n}\n\n.theia-marker-container .markerNode .message {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.theia-marker-container .row-button-container {\n  display: none;\n}\n\n.theia-marker-container .theia-TreeNodeContent:hover .row-button-container {\n  display: flex;\n  justify-content: flex-end;\n  flex: 1;\n  align-items: center;\n  align-self: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
